<template>
    <div class="server-errors">
        <p>{{ $t('f_server_error_message') }}</p>
        <p>Error: {{ message }}</p>
    </div>
</template>

<script>
  export default {
    props: ['message']
  }
</script>

<style lang="scss" scoped>
  @import '~@stylesheets/_vars.scss';

  .server-errors {
    padding: .75em 1.25em;
    background-color: #f8d7da;
    border: 1px solid #f5c6cb;
    color: #721c24;
    border-radius: .25em;
  }
</style>
